// extracted by mini-css-extract-plugin
export var banner = "_df-0";
export var closeButton = "_df-2";
export var greenCheckmark = "_df-3";
export var hereLink = "_df-4";
export var titleIcon = "_df-1";